module.exports = __webpack_public_path__ + "img/move-board-icon.17f00502.svg";